import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import ConsolePlaceholder from './pages/ConsolePlaceholder';
import OfferingsPage from './pages/OfferingsPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RequireAuth from './components/RequireAuth';

const App: React.FC = () => (
  <Routes>
    <Route path="/register" element={<RegisterPage />} />
    <Route path="/login" element={<LoginPage />} />
    {/* Targets of the operator mails (${OPERATOR_CONSOLE_URL}/…#token=). Public:
        no RequireAuth, and above "*", which would drop the fragment. */}
    <Route path="/verify-email" element={<VerifyEmailPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route
      path="/console"
      element={
        <RequireAuth>
          <ConsolePlaceholder />
        </RequireAuth>
      }
    />
    <Route
      path="/console/stalls/:stallId/offerings"
      element={
        <RequireAuth>
          <OfferingsPage />
        </RequireAuth>
      }
    />
    <Route path="/" element={<Navigate to="/console" replace />} />
    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default App;
